<template>
  <div>
    <el-transfer
      style="text-align: left; display: inline-block"
      v-model="selectedUserListData"
      filterable
      :titles="[
        $l('label_userlist') || '待选用户列表',
        $l('label_selecteduserlist') || '已选用户列表'
      ]"
      :format="{
        noChecked: '${total}',
        hasChecked: '${checked}/${total}'
      }"
      :props="{
        key: 'userCode',
        label: 'userFullName'
      }"
      @change="handleChange"
      :data="userListData"
    >
    </el-transfer>
  </div>
</template>
<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCustomerSettingCode: { type: String, default: '' }
  },
  data() {
    return {
      userListData: [],
      selectedUserListData: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleChange(value, direction, movedKeys) {
      this.$api
        .shipmentCustomerSettingUserRangeSaveApi({
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode,
          userCodeList: value.filter(Boolean)
        })
        .catch(() => {
          // 当出现异常时，还原移动的item
          if (direction === 'right') {
            this.selectedUserListData = this.selectedUserListData.filter(
              (item) => movedKeys.indexOf(item) < 0
            )
          } else {
            this.selectedUserListData.push(...movedKeys)
          }
        })
    },
    getData() {
      if (!this.shipmentCustomerSettingCode) {
        return
      }

      // 获取全部用户列表及已选用户列表
      Promise.all([
        this.$api.shipmentCustomerSettingUserRangeGetUserCodeListApi({
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode
        }),
        this.$api.factoryUserOptsList()
      ]).then(([seletedRes, allRes]) => {
        this.userListData =
          allRes.body.data.map((item) => ({
            ...item,
            disabled: this.disabled
          })) || []
        this.selectedUserListData = seletedRes.body.data || []
      })
    }
  }
}
</script>
